import styles from "./style.module.css";
import { useEffect } from "react";
import { NavIcon } from "../NavIcon";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  changeSelectedTab,
  changeSidebarOpenStatus,
} from "../../reducers/appSlice";
import { resetUser } from "../../reducers/authSlice";
import { CustomButton } from "../CustomButton";

const sidebarItems = [
  {
    label: "Dashboard",
    caption: "Business analytics",
    icon: "dashboard",
    route: "/dashboard",
    matchPaths: ["/dashboard"],
  },
  {
    label: "Companies",
    caption: "Accounts and plans",
    icon: "customer",
    route: "/companies",
    matchPaths: ["/companies", "/company"],
  },
  {
    label: "Notifications",
    caption: "Announcements and alerts",
    icon: "category",
    route: "/notifications",
    matchPaths: ["/notifications"],
  },
  // {
  //   label: "Profile",
  //   caption: "Personal and billing details",
  //   icon: "customer",
  //   route: "/userprofile",
  //   matchPaths: ["/userprofile"],
  // },
  // {
  //   label: "Tickets",
  //   caption: "Support queues",
  //   icon: "category",
  //   route: "/tickets/dashboard",
  //   matchPaths: ["/tickets/dashboard", "/tickets"],
  // },
  // {
  //   label: "Ticket Support",
  //   caption: "Live workspace",
  //   icon: "category",
  //   route: "/tickets/workspace",
  //   matchPaths: ["/tickets/workspace"],
  // },
];

Object.freeze(sidebarItems);

const isItemActive = (pathname, item) =>
  item.matchPaths.some((match) => pathname === match || pathname.startsWith(`${match}/`));

export const Sidebar = () => {
  const { selectedTab, slidebarOpen, sidebarCollapsed } = useSelector(
    (state) => state.application
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const handleNav = (route) => {
    dispatch(changeSelectedTab(route));
    if (slidebarOpen) dispatch(changeSidebarOpenStatus());
    navigate(route);
  };

  const handleLogout = () => {
    dispatch(resetUser());
    navigate("/login");
  };

  useEffect(() => {
    dispatch(changeSelectedTab(location.pathname));
  }, [location.pathname, dispatch]);

  return (
    <>
      <aside
        className={`${styles.sidebar} ${
          slidebarOpen ? styles.open : ""
        } ${sidebarCollapsed ? styles.collapsed : ""}`}
      >
        <div className={styles.sidebarContent}>
          <div>
            <ul className={styles.navList}>
              {sidebarItems.map((item) => {
                const active =
                  isItemActive(location.pathname, item) ||
                  isItemActive(selectedTab, item);

                return (
                  <li
                    key={item.route}
                    className={`${styles.navItem} ${active ? styles.active : ""}`}
                    onClick={() => handleNav(item.route)}
                  >
                    <span className={styles.iconWrap}>
                      <span className={styles.icon}>
                        <NavIcon icon={item.icon} />
                      </span>
                    </span>
                    <span className={styles.labelBlock}>
                      <span className={styles.label}>{item.label}</span>
                      <span className={styles.caption}>{item.caption}</span>
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>

          <div className={styles.sidebarFooter}>
            <div className={styles.signout}>
              <CustomButton
                label="Sign out"
                icon="pi pi-sign-out"
                onClick={handleLogout}
                varient="outline-white"
              />
            </div>
          </div>
        </div>
      </aside>

      {slidebarOpen && (
        <div
          className={styles.overlay}
          onClick={() => dispatch(changeSidebarOpenStatus())}
        />
      )}
    </>
  );
};
